import { Component, computed, inject, OnInit, Signal } from '@angular/core';
import { TherapistClientStateService } from '@therapist/shared/services/state/therapist-client-state.service';
import { TherapistClientDto } from '@therapist/shared/models/client/therapist-client.dto';
import { Router, RouterLink } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ClientTherapyPlanListComponent } from '../client-therapy-plans/client-therapy-plan-list.component';
import { TherapyPlanListItemDto } from '@therapist/shared/models/therapy-plan/therapy-plan-list-item.dto';
import { ExerciseStateService } from '@therapist/shared/services/state/exercise-state.service';
import { TherapyPlanStateService } from '@therapist/shared/services/state/therapy-plan-state.service';
import { Badge } from 'primeng/badge';
import { DialogService } from 'primeng/dynamicdialog';
import { Button } from 'primeng/button';
import { MessageService } from 'primeng/api';
import { TherapistClientApiService } from '@therapist/shared/services/api/therapist-client-api.service';

@Component({
  selector: 'sana-tp-client-details',
  imports: [
    DatePipe,
    ClientTherapyPlanListComponent,
    RouterLink,
    Badge,
    Button
  ],
  templateUrl: './client-details-page.component.html',
  styleUrl: './client-details-page.component.scss',
  providers: [DialogService]
})
export class ClientDetailsPageComponent implements OnInit {

  readonly #therapistClientApiService = inject(TherapistClientApiService);
  readonly #clientStateService = inject(TherapistClientStateService);
  readonly #exerciseStateService = inject(ExerciseStateService);
  readonly #therapyPlanStateService = inject(TherapyPlanStateService);
  readonly #router = inject(Router);
  readonly #messageService = inject(MessageService)

  selectedClient: Signal<TherapistClientDto> = this.#clientStateService.getSelectedClient() as Signal<TherapistClientDto>;
  selectedClientId = computed(() => this.selectedClient()?.id);

  therapyPlans: Signal<TherapyPlanListItemDto[]> = this.#therapyPlanStateService.getClientTherapyPlans();

  isInviteSending = false;

  constructor() {
    this.#therapyPlanStateService.loadTherapyPlanListByClientId(this.selectedClientId()!);
  }

  ngOnInit() {
    this.#therapyPlanStateService.removeAllTherapyPlanExercises();
    this.#therapyPlanStateService.removeSelected();
    this.#exerciseStateService.removeAllExercises();

    this.#therapyPlanStateService.loadPreviousTherapyPlan(this.selectedClientId()!)
  }

  routeToNewTherapyPlan(): void {
    this.#router.navigate([`/client/${this.selectedClient()!.id}/therapy-plan/add`]);
  }

  sendAppInvite(): void {
    this.isInviteSending = true;

    this.#therapistClientApiService
      .resendInvite(this.selectedClientId()!)
      .subscribe(response => {
        this.isInviteSending = false
        this.#messageService.add({
          severity: 'success',
          summary: 'Einladungslink erneut gesendet',
          detail: `Der Einladungslink wurde erneut an ${this.selectedClient()!.email} gesendet.`
        });
      });
  }
}
